import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateTimePickerControls = _resolveComponent("DateTimePickerControls")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tw-w-full",
    onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInputKeydown && _ctx.onInputKeydown(...args))),
    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInputTyped && _ctx.onInputTyped(...args))),
    onChangeCapture: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setIsCommittingTypedTextOnBlur(true))),
    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setIsCommittingTypedTextOnBlur(false)))
  }, [
    (_ctx.textLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.textLabel), 1),
          _renderSlot(_ctx.$slots, "label-suffix")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DatePicker, _mergeProps(_ctx.$attrs, {
      value: _ctx.resolvedPickerValue,
      type: _ctx.resolvedType,
      format: _ctx.resolvedFormat,
      open: _ctx.isPopupOpen,
      "onUpdate:open": _ctx.setIsPopupOpen,
      "onUpdate:value": _ctx.onUpdateValue,
      onChange: _ctx.onChange,
      onInputError: _ctx.clearTypedPreviewValue,
      "input-class": "tw-w-full tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/20",
      "popup-class": _ctx.resolvedPopupClass,
      "append-to-body": true,
      "popup-style": _ctx.resolvedPopupStyle,
      "show-time-panel": _ctx.getIsTimePanelBesideCalendar || undefined
    }), _createSlots({ _: 2 }, [
      (_ctx.getIsShowingControlsInPopup)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createVNode(_component_DateTimePickerControls, {
                "allow-time-toggling": _ctx.allowTimeToggling,
                "show-days-shortcuts": _ctx.showDaysShortcuts,
                "is-time-enabled": _ctx.isTimeEnabled,
                "is-disabled": _ctx.getIsDisabled,
                class: "tw-justify-start",
                onToggleTime: _ctx.toggleIsTimeEnabled,
                onSetToday: _ctx.setDateToToday,
                onShiftDays: _ctx.shiftDateByDays
              }, null, 8, ["allow-time-toggling", "show-days-shortcuts", "is-time-enabled", "is-disabled", "onToggleTime", "onSetToday", "onShiftDays"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["value", "type", "format", "open", "onUpdate:open", "onUpdate:value", "onChange", "onInputError", "popup-class", "popup-style", "show-time-panel"]),
    (_ctx.getIsShowingControlsBelowInput)
      ? (_openBlock(), _createBlock(_component_DateTimePickerControls, {
          key: 1,
          "allow-time-toggling": _ctx.allowTimeToggling,
          "show-days-shortcuts": _ctx.showDaysShortcuts,
          "is-time-enabled": _ctx.isTimeEnabled,
          "is-disabled": _ctx.getIsDisabled,
          class: "tw-mt-1.5",
          onToggleTime: _ctx.toggleIsTimeEnabled,
          onSetToday: _ctx.setDateToToday,
          onShiftDays: _ctx.shiftDateByDays
        }, null, 8, ["allow-time-toggling", "show-days-shortcuts", "is-time-enabled", "is-disabled", "onToggleTime", "onSetToday", "onShiftDays"]))
      : _createCommentVNode("", true)
  ], 32))
}